import { render } from "./InventoryHistory.vue?vue&type=template&id=3acb62f0&scoped=true"
import script from "./InventoryHistory.vue?vue&type=script&lang=js"
export * from "./InventoryHistory.vue?vue&type=script&lang=js"

import "./InventoryHistory.vue?vue&type=style&index=0&id=3acb62f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acb62f0"]])

export default __exports__